/* RESPONSIBLE TEAM: team-fin-voice */
/* eslint-disable @intercom/intercom/no-bare-strings */

export type FinVoiceVoiceModelOptions = {
  value: FinVoiceVoiceModel;
  text: string;
};

export type FinVoiceVoiceModel =
  | 'eleven_turbo_v2'
  | 'eleven_turbo_v2_5'
  | 'eleven_flash_v2_5'
  | 'eleven_multilingual_v2'
  | 'sonic-3'
  | 'sonic-3-5';

export const FIN_VOICE_VOICE_MODEL_OPTIONS: FinVoiceVoiceModelOptions[] = [
  { value: 'eleven_turbo_v2', text: 'Turbo' },
  { value: 'eleven_turbo_v2_5', text: 'Turbo 2.5' },
  { value: 'eleven_flash_v2_5', text: 'Flash' },
  { value: 'eleven_multilingual_v2', text: 'Multilingual' },
  { value: 'sonic-3', text: 'Sonic' },
  { value: 'sonic-3-5', text: 'Sonic 3.5' },
];

export const CARTESIA_VOICE_MODELS = new Set<FinVoiceVoiceModel>(['sonic-3', 'sonic-3-5']);
